/* eslint-disable react/prop-types */
import React from 'react';

import removeWhiteSpace from '../../constants/removeSpace';
import '../SmartDisplay/SmartDisplay.scss';
import {ToolTip} from '../';
import { updateYear } from '../../utils/utils';
import { lockMsg, lockMsgAdmin } from '../../constants/messages';
import { ADMIN_ROLE } from '../../constants/global';

const DateInput = props => {
  const {apcp, inputId, halfInput, requiredInput, question_tooltip, org_rol, errorId, children, readOnly, showQlock, inputLabel, inputName, textvalue, onChangeInputValue, errMsg='Error', successMsg='Success'} = props;
  return(
    <div id={`${errorId}_one`} className='fieldArrangement'>
      <div className='cb-input cb-input-condensed col-md-12 fieldInput'>
        <div id={`${errorId}_two`} className='cb-validation-label-input'>
          <div className={`display-flex ${halfInput?'col-md-12':'col-md-6'}`} >
            {children}
            <label className={`${requiredInput?'cb-required':''}`} htmlFor={`date`+removeWhiteSpace(inputId)}>{inputLabel}</label>
            {
              !apcp&&question_tooltip?<ToolTip tooltipid={`smartdisplayDate${removeWhiteSpace(inputId)}id`} 
                                        tooltipMsg={question_tooltip} 
                                        innerMsg={<span className="cb-icon cb-user"></span>} 
                                        className={'questionToolTip'}
                                        />
                                        :''
            }
          </div>
          <div className={`lineupinput ${halfInput?'col-md-12':'col-md-6'}`}>
            <input
              type='date'
              data-cb-placeholder={`MM/DD/2022`}
              id={removeWhiteSpace(`${inputId}`)}
              aria-required={requiredInput}
              name={inputName}
              data-testid='datainput'
              disabled={readOnly}
              aria-readonly={readOnly}
              value={textvalue}
              onChange={event => onChangeInputValue(updateYear(event.target.value))}
            />
              {showQlock?
                <ToolTip tooltipid={`datetooltip${inputId}`} 
                tooltipMsg={org_rol===ADMIN_ROLE?lockMsgAdmin:lockMsg}
                className={'cb-icon cb-lock'} />:''
              }
          </div>
        </div>
      </div>
      <div className='errorDiv'>
        <p id={`${errorId}_s`} style={{display: 'none'}}>{successMsg}</p>
        <p id={`${errorId}_e`} style={{display: 'none'}}>{errMsg}</p>
      </div>
    </div>
  );
};

export default DateInput;